import { axiosInstance } from './http';
import type { AdminLook } from '../shared/design/looks';

/** Platform-wide admin look (`/platform-settings/admin-look`). null = older backend (404). */
export async function getAdminLook(): Promise<{ look: AdminLook } | null> {
  try {
    return (await axiosInstance.get('/platform-settings/admin-look')).data;
  } catch (e: any) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

/** Platform admins only (SSO `admin`); unknown look = 400 `BAD_ADMIN_LOOK`. */
export async function putAdminLook(look: AdminLook): Promise<AdminLook> {
  return (await axiosInstance.put('/platform-settings/admin-look', { look })).data.look;
}
